// extracted by mini-css-extract-plugin
module.exports = {"sauron-empty-card":"sauronEmptyCard_sauron-empty-card__QIsEM"};